import styled from 'styled-components';
import { EXTRA_LARGE_VIEWPORT, MOBILE_VIEWPORT } from 'modules/theme/config';

export const DailyDealWrapper = styled.div`
  display: flex;
  align-items: center;

  a, a:hover {
    text-decoration: none;
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    flex-wrap: wrap;
    gap: 8px;

    svg {
      width: 22px;
      height: auto;
    }
  }
`;

export const DailyDealLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    width: 100%;
  }
`;

export const DailyDealTitle = styled.span`
  font-size: 28px;
  font-weight: 700;
  line-height: 32px;
  width: 74px;
  margin-left: 16px;
  opacity: 0.8;
  letter-spacing: 0.06em;

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    font-size: 18px;
    line-height: 24px;
    width: 48px;
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    font-size: 14px;
    line-height: 1.2;
    width: auto;
    margin-left: 0;
  }
`;

export const DailyDealItem = styled.div`
  background-color: ${({ theme }) => theme.colors.lightGrey};
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  margin-left: 16px;
  gap: 8px;

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    padding: 4px;
    border-radius: 8px;
    margin-left: 0;
    gap: 10px;
  }
`;

export const DailyDealPrice = styled.span`
  font-size: 36px;
  line-height: 32px;
  font-weight: 500;
  
  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    font-size: 24px;
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    font-size: 16px;
  }
`;

export const DailyDealDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 16px;
  white-space: pre;
  color: ${({ theme }) => theme.colors.darkGrey};

  span {
    display: inline-flex;
    svg {
      margin-right: 8px;
      fill: ${({ theme }) => theme.colors.darkGrey};
    }
  }

  > span:last-child {
    margin-top: 8px;
  }
  
  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    font-size: 14px;

    span {
      svg {
        margin-right: 5px;
      }
    }
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    font-size: 10px;

    span {
      svg {
        width: 12px;
        height: auto;
      }
    }

    > span:last-child {
      margin-top: 0;
    }
  }
`;
